<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12>
						<v-subheader class="px-0 subheading">
							Rol Original: {{ roleName }}
						</v-subheader>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							required
							v-model="$v.model.name.$model"
							:error="$v.model.name.$error"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const PAGE_ROLE_LIST = 'page-role';

function closeModal() {
	this.goTo(PAGE_ROLE_LIST);
}

async function submitForm() {
	const headers = {
		Accept: process.env.ACCEPT_SERVICE_V2,
	};
	this.loading = true;
	try {
		await this.$http.post(`role/${this.roleId}/duplicate`, this.model, { headers });
		this.goTo(PAGE_ROLE_LIST);
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		loading: false,
		model: {
			name: '',
		},
	};
}

export default {
	name: 'role-duplicate-form',
	data,
	methods: {
		closeModal,
		submitForm,
	},
	props: {
		roleId: {
			type: [Number, String],
		},
		roleName: {
			type: String,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-duplicate-form.vue